
import type RequestsController from '../requests';

import { Core } from './core';
import { Messages } from './messages';
import { Unit } from './unit';
import { Root } from './root';
import { Render } from './render';
import { Events } from './events';

export type WialonSections = {
  Core: Core;
  Messages: Messages;
  Unit: Unit;
  Root: Root;
  Render: Render;
  Events: Events;
};

export default (requestController: RequestsController): WialonSections => ({
  Core: new Core(requestController),
  Messages: new Messages(requestController),
  Unit: new Unit(requestController),
  Root: new Root(requestController),
  Render: new Render(requestController),
  Events: new Events(requestController)
});
